import {NgModule} from '@angular/core';
import {BrowserModule} from '@angular/platform-browser';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HttpClientModule, HTTP_INTERCEPTORS} from '@angular/common/http';


// Import routing module
import {AppRoutingModule} from './app.routing';

// Import 3rd party components
import {BsDropdownModule} from 'ngx-bootstrap/dropdown';
import {TabsModule} from 'ngx-bootstrap/tabs';
import {ChartsModule} from 'ng2-charts/ng2-charts';

import {
    FullLayoutComponent,
    SimpleLayoutComponent
} from './core/containers';

const APP_CONTAINERS = [
    FullLayoutComponent,
    SimpleLayoutComponent
]
import {
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
} from './core/directives';

const APP_DIRECTIVES = [
    AsideToggleDirective,
    NAV_DROPDOWN_DIRECTIVES,
    ReplaceDirective,
    SIDEBAR_TOGGLE_DIRECTIVES
]

/** Modules */
import {Ng2Webstorage} from 'ngx-webstorage';
import {FileModule} from './files/file.module';
import {ConfigModule} from './config/config.module';
import {SharedModule} from './shared/shared.module';

/** Components CORE */
import {AppComponent} from './app.component';
import {HeaderComponent} from './core/components/layout/header/header.component';
import {SidebarComponent} from './core/components/layout/sidebar/sidebar.component';
import {NavbarComponent} from './core/components/layout/navbar/navbar.component';
import {FooterComponent} from './core/components/layout/footer/footer.component';
import {SidebarLeftComponent} from './core/components/layout/sidebar-left/sidebar-left.component';
import {APP_SIDEBAR_NAV} from './core/components/layout/sidebar-menu/sidebar-menu.component';
import {LoginComponent} from './core/components/login/login.component';

/** Service */

import {AuthGuardService} from './core/service/auth-guard.service';
import {AuthService} from './core/service/auth.service';
import {ApiService} from './core/service/api.service';
import {EnvironmentService} from './core/service/environment.service';
import {DatesParserService} from './core/service/dates_parser.service';
import {ReportingService} from './reporting/services/reporting.service';

import {HttpInterceptorService } from './core/service/http-interceptor.service';
import { UserbarComponent } from './core/components/layout/userbar/userbar.component';
import { AutoLoginComponent } from './core/components/auto-login/auto-login.component';
import { EmailRecoverPasswordComponent } from './core/components/email-recover-password/email-recover-password.component';
import { ChangePasswordComponent } from './core/components/change-password/change-password.component';
import { CallsComponent } from './reporting/components/calls/calls.component';
import {ReportingModule} from './reporting/reporting.module';
import {UserModule} from './user/user.module';


@NgModule({
    imports: [
        CommonModule,
        BrowserModule,
        AppRoutingModule,
        BsDropdownModule.forRoot(),
        TabsModule.forRoot(),
        ChartsModule,
        FormsModule,
        HttpClientModule,
        ReactiveFormsModule,
        Ng2Webstorage,
        SharedModule,
        FileModule,
        ConfigModule,
        ReportingModule,
        UserModule
    ],
    declarations: [
        AppComponent,
        ...APP_CONTAINERS,
        ...APP_DIRECTIVES,
        HeaderComponent,
        SidebarComponent,
        NavbarComponent,
        FooterComponent,
        SidebarLeftComponent,
        APP_SIDEBAR_NAV,
        LoginComponent,
        UserbarComponent,
        AutoLoginComponent,
        EmailRecoverPasswordComponent,
        ChangePasswordComponent
    ],
    providers: [
        AuthGuardService,
        AuthService,
        ApiService,
        EnvironmentService,
        DatesParserService,
        ReportingService,
        { provide: HTTP_INTERCEPTORS, useClass: HttpInterceptorService, multi: true }
    ],
    bootstrap: [AppComponent]
})
export class AppModule {
}



// WEBPACK FOOTER //
// /home/jacobo/proyectos/venta-extranet/src/app/app.module.ts